export default "__VITE_ASSET__137d6106__"